(function() {
    'use strict';

    angular.module('stats')
        .directive('cpSalesStats', cpSalesStats);

        cpSalesStats.$inject = ['$state', 'salesStatsDataSrvc', 'dateFormatConst', 'momentSrvc', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'filterQuerySrvc', 'previewStatsSrvc'];

    function cpSalesStats($state, salesStatsDataSrvc, dateFormatConst, momentSrvc, datatableDefaultPageSizeValueConst, checkSearchSrvc, filterQuerySrvc, previewStatsSrvc) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/stats/directives/sales-stats/sales-stats.html',
            scope: {
                isDefault: '=',
                weeks: '=',
                months: '=',
                years: '=',
                shopVersion: '=',
                parentIndex: '='
            },
            link: function(scope, element, attrs, controller) {
                var self = scope;

                self.tableTitle = 'Statystyki sprzedaży - Tabela ' + (scope.parentIndex + 1); 

                self.loading = false;

                self.pageOpts = {
                    count: undefined,
                    page: 1,
                    pageSize: datatableDefaultPageSizeValueConst
                };
                self.dateRange = {daterangeFilter: {startDate: null, endDate: null}}
                self.shopVersionOptions = [];
                self.groupByDatesOptions = [];

                self.summaryCols = {
                    'net_sum_without_delivery_costs': 'net_sum_without_delivery_costs',
                    'num_of_orders': 'num_of_orders',
                    'num_of_on_cash_delivery_orders': 'num_of_on_cash_delivery_orders',
                    'num_of_order_products': 'num_of_order_products',
                    'num_of_orders_sent_on_day_set_by_system': 'num_of_orders_sent_on_day_set_by_system',
                    'num_of_delayed_orders': 'num_of_delayed_orders'
                }
                
                self.salesStatsRows = [];
                self.salesStatsCols = [{
                    title: 'Data',
                    value: 'date_to_display',
                    type: 'date',
                    orderable: false
                },{
                    title: 'Wartość zamówień netto bez kosztów przesyłki i podziału zamówienia',
                    value: 'net_sum_without_delivery_costs',
                    type: 'number',
                    orderable: true
                },{
                    title: 'Ilość zamówień',
                    value: 'num_of_orders',
                    type: 'number',
                    orderable: true
                }, {
                    title: 'Ilość zamówień pobraniowych',
                    value: 'num_of_on_cash_delivery_orders',
                    type: 'number',
                    orderable: true
                }, {
                    title: 'Ilość zamówionych produktów',
                    value: 'num_of_order_products',
                    type: 'number',
                    orderable: true
                }, {
                    title: 'Ilość zamówień wysłanych w dniu wyznaczonym przez system',
                    value: 'num_of_orders_sent_on_day_set_by_system',
                    type: 'number',
                    orderable: true
                }, {
                    title: 'Ilość zamówień opóźnionych',
                    value: 'num_of_delayed_orders',
                    type: 'number',
                    orderable: true
                }, {
                    title: 'Max ilość dni opóźnienia',
                    value: 'num_of_delayed_days_max',
                    type: 'number',
                    orderable: true
                }, {
                    title: 'Min ilość dni opóźnienia',
                    value: 'num_of_delayed_days_min',
                    type: 'number',
                    orderable: true
                }];

                self.searchQuery = {
                    pk: null,
                    name: null,
                    ordering: null
                };

                self.dateFormat = dateFormatConst.defaultPythonDate;
                self.filterData = {
                    min_date: null,
                    max_date: null,
                    shop_version: null,
                    group_by_date: 'years'
                };

                self.pageChange = pageChange;
                self.onSearchQueryChange = onSearchQueryChange;
                self.changeFilter = changeFilter;

                self.setChartData = setChartData;
                self.setChartLabels = setChartLabels;

                self.chartLabels = [];
                self.salesChartsInfo = {
                    'net_sum_without_delivery_costs': {
                        chartData: [],
                    },
                    'num_of_orders': {
                        chartData: [],
                    }, 
                    'num_of_on_cash_delivery_orders': {
                        chartData: [],
                    }, 
                    'num_of_order_products': {
                        chartData: [],
                    }, 
                    'num_of_orders_sent_on_day_set_by_system': {
                        chartData: [],
                    }, 
                    'num_of_delayed_orders': {
                        chartData: [],
                    }, 
                    'num_of_delayed_days_max': {
                        chartData: [],
                    },
                    'num_of_delayed_days_min': {
                        chartData: [],
                    }          
                }

                activate();

                function activate() {
                    self.filterData = filterQuerySrvc.initializeFilterData(self.filterData);
                    self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
                    self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
                    getShopVersions();
                    getGroupByDatesOptions();
                    filterQuerySrvc.setLocationParams();
                    var minDate = moment(self.filterData.min_date, 'DD.MM.YYYY');
                    var maxDate = moment(self.filterData.max_date, 'DD.MM.YYYY');
                    if (!scope.isDefault){
                        if (scope.weeks) {
                            minDate = minDate.subtract(scope.weeks, 'w')
                            maxDate = maxDate.subtract(scope.weeks, 'w')
                        }
                        if (scope.months) {
                            minDate = minDate.subtract(scope.months, 'M')
                            maxDate = maxDate.subtract(scope.months, 'M')
                        }
                        if (scope.years) {
                            minDate = minDate.subtract(scope.years, 'y')
                            maxDate = maxDate.subtract(scope.years, 'y')
                        }
                        self.filterData.min_date = minDate.format(dateFormatConst.backendDate);
                        self.filterData.max_date = maxDate.format(dateFormatConst.backendDate);;
                    }

                    if (self.filterData.min_date) {
                        self.dateRange.daterangeFilter['startDate'] = minDate;
                        self.dateRange.daterangeFilter['endDate'] = maxDate;
                    }
                    getSalesStats();
                }

                function getShopVersions() {
                    salesStatsDataSrvc.shopVersions().$promise.then(
                        function(response) {
                            self.shopVersionOptions = response;
                        }
                    )
                }

                function getGroupByDatesOptions() {
                    salesStatsDataSrvc.groupByDatesOptions().$promise.then(
                        function(response) {
                            self.groupByDatesOptions = response;
                        }
                    )
                }

                function getSalesStats(filterObj) {
                    if(self.loading)
                        return;
                    
                    self.loading = true;
                    if (!filterObj) {
                        filterObj = {
                            page: self.pageOpts.page,
                            page_size: self.pageOpts.pageSize,

                            pk: self.searchQuery.pk,
                            name: self.searchQuery.name,
                            ordering: self.searchQuery.ordering,

                            min_date: self.filterData.min_date || null,
                            max_date: self.filterData.max_date || null,
                            shop_version: self.filterData.shop_version || null,
                            group_by_date: self.filterData.group_by_date || null
                        }
                    }
                    salesStatsDataSrvc.list(filterObj)
                        .$promise
                        .then(
                            function (response) {
                                self.salesStatsRows = response.results;
                                self.setChartData(response.results);
                                self.setChartLabels(response.results);
                                self.pageOpts.count = response.count;
                                var chartsData = {
                                    salesChartsInfo: self.salesChartsInfo,
                                    chartLabels: self.chartLabels
                                }
                                self.$emit('charts-data', chartsData);
                            },
                            function (response) {
                                if (response.status === 404 && filterObj.page !== 1) {
                                    checkSearchSrvc.recall(filterObj, getSalesStats);
                                }
                            }
                        )
                        .finally(
                            function(response) {
                                self.loading = false;
                                return response;
                            }
                        );
                }

                function pageChange() {
                    filterQuerySrvc.updatePageOpts(self.pageOpts);
                    filterQuerySrvc.setLocationParams();
                    self.$emit('reset-charts-data');
                    getSalesStats();
                }

                function onSearchQueryChange() {
                    filterQuerySrvc.updateSearchQuery(self.searchQuery);
                    filterQuerySrvc.setLocationParams();
                    self.$emit('reset-charts-data');
                    getSalesStats();
                }

                function changeFilter() {
                    if (self.dateRange.daterangeFilter.startDate) {
                        self.filterData.min_date = self.dateRange.daterangeFilter.startDate.format(dateFormatConst.backendDate);
                        self.filterData.max_date = self.dateRange.daterangeFilter.endDate.format(dateFormatConst.backendDate)
                    } else {
                        self.filterData.min_date = null;
                        self.filterData.max_date = null;
                    }
                    if (scope.isDefault) {
                        filterQuerySrvc.updateFilterData(self.filterData);
                        filterQuerySrvc.setLocationParams();
                    }
                    self.$emit('reset-charts-data');
                    getSalesStats();
                }

                function setChartData(results) {
                    for(var prop in self.salesChartsInfo) {
                        self.salesChartsInfo[prop].chartData = [];
                    }

                    results.forEach(function(result) {
                        for(var prop in result) {
                            if(prop in self.salesChartsInfo) {
                                self.salesChartsInfo[prop].chartData.unshift(result[prop]);
                            } 
                        }
                        
                    });
                }

                function setChartLabels(results) {
                    self.chartLabels = results.map(function(result) {
                        return result.date_to_display;
                    }).reverse();
                }
            }
        };
    }
})();
